export { default } from './TouchFeedback';


//////////////////
// WEBPACK FOOTER
// ./~/rmc-feedback/es/index.js
// module id = 366
// module chunks = 121